 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		14: 0,
 		79: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		14: 0,
 		79: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"2":"vendors~route-MapView~route-account~route-album~route-feed~route-habitat~route-habitats~route-help~r~1d0b5a67","3":"vendors~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCameraSe~ffd0fef2","4":"route-MapView~route-account~route-album~route-feed~route-habitats~route-help~route-notifications~rou~b15ca37e","5":"route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCameraSettings~r~45a4aed9","6":"route-album~route-feed~route-habitats~route-help~route-notifications~route-talkSchedule","7":"vendors~route-habitat~route-highlights~route-home~route-schedule~route-zoo","17":"route-MapView","18":"route-TermsAndPrivacy","19":"route-account","20":"route-adminAdvertisements","21":"route-adminAnnouncements","22":"route-adminCameraInfo","23":"route-adminCameraSettings","24":"route-adminConfigurations","25":"route-adminHabitats","26":"route-adminOnlineUsersInfo","27":"route-adminPartners","28":"route-adminPlaylists","29":"route-adminTestNewModelsForAiKeeper","30":"route-adminUsers","31":"route-album","32":"route-emailVerify","33":"route-feed","34":"route-gift","35":"route-habitat","36":"route-habitatPreview","37":"route-habitats","38":"route-help","39":"route-highlights","40":"route-home","41":"route-importBundleUsers","42":"route-login","43":"route-myAlbum","44":"route-notFound","45":"route-notifications","46":"route-partnerDonationRedirect","47":"route-passwordReset","48":"route-profile","49":"route-redeem","50":"route-reports","51":"route-schedule","52":"route-signup","53":"route-socialLogin","54":"route-softReload","55":"route-start","56":"route-talkSchedule","57":"route-welcome","58":"route-zoo"}[chunkId]||chunkId) + ".chunk." + {"0":"b1ab3","1":"5fe33","2":"f12b5","3":"faa85","4":"7172d","5":"d7d44","6":"2f186","7":"797e9","8":"9a87c","9":"31705","10":"a0c7e","11":"7664b","12":"d6537","13":"dbfaf","17":"ada99","18":"66d7e","19":"04ac3","20":"3da10","21":"81a8c","22":"5185a","23":"1d33b","24":"042a3","25":"110f3","26":"5f7b5","27":"76e2f","28":"67413","29":"b8798","30":"9fa7f","31":"e8551","32":"f3ee6","33":"4c58d","34":"6e59a","35":"f8947","36":"c6930","37":"a77ff","38":"1c8a2","39":"c974a","40":"89ff3","41":"cf1ed","42":"91354","43":"5eb1c","44":"a3158","45":"c2a17","46":"f8a1f","47":"caa73","48":"a71fc","49":"fcca3","50":"98316","51":"202b6","52":"e78f5","53":"15227","54":"ea8c4","55":"0b489","56":"8118a","57":"829d8","58":"52c83","59":"d3a11","60":"bc384","61":"e8a9e","62":"83412","63":"30409","64":"c4b3d","65":"1bbcf","66":"fbc8e","67":"dfc7b","68":"107d5","69":"552a8","70":"9faf2","71":"2ae26","72":"06b0f","73":"5b4ae","74":"83818","75":"9f90b","76":"a2150","77":"b4374","78":"c9fc6","80":"9cbee","81":"a5748","82":"d1682","83":"fef18"}[chunkId] + ".esm.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"4":1,"5":1,"10":1,"11":1,"12":1,"13":1,"17":1,"19":1,"23":1,"25":1,"27":1,"30":1,"31":1,"32":1,"34":1,"35":1,"37":1,"38":1,"39":1,"40":1,"42":1,"43":1,"44":1,"46":1,"47":1,"48":1,"49":1,"50":1,"51":1,"52":1,"56":1,"58":1,"59":1,"60":1,"61":1,"62":1,"63":1,"64":1,"65":1,"66":1,"71":1,"72":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"2":"vendors~route-MapView~route-account~route-album~route-feed~route-habitat~route-habitats~route-help~r~1d0b5a67","3":"vendors~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCameraSe~ffd0fef2","4":"route-MapView~route-account~route-album~route-feed~route-habitats~route-help~route-notifications~rou~b15ca37e","5":"route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCameraSettings~r~45a4aed9","6":"route-album~route-feed~route-habitats~route-help~route-notifications~route-talkSchedule","7":"vendors~route-habitat~route-highlights~route-home~route-schedule~route-zoo","17":"route-MapView","18":"route-TermsAndPrivacy","19":"route-account","20":"route-adminAdvertisements","21":"route-adminAnnouncements","22":"route-adminCameraInfo","23":"route-adminCameraSettings","24":"route-adminConfigurations","25":"route-adminHabitats","26":"route-adminOnlineUsersInfo","27":"route-adminPartners","28":"route-adminPlaylists","29":"route-adminTestNewModelsForAiKeeper","30":"route-adminUsers","31":"route-album","32":"route-emailVerify","33":"route-feed","34":"route-gift","35":"route-habitat","36":"route-habitatPreview","37":"route-habitats","38":"route-help","39":"route-highlights","40":"route-home","41":"route-importBundleUsers","42":"route-login","43":"route-myAlbum","44":"route-notFound","45":"route-notifications","46":"route-partnerDonationRedirect","47":"route-passwordReset","48":"route-profile","49":"route-redeem","50":"route-reports","51":"route-schedule","52":"route-signup","53":"route-socialLogin","54":"route-softReload","55":"route-start","56":"route-talkSchedule","57":"route-welcome","58":"route-zoo"}[chunkId]||chunkId) + ".chunk." + {"0":"31d6c","1":"31d6c","2":"31d6c","3":"31d6c","4":"09dc2","5":"ee920","6":"31d6c","7":"31d6c","8":"31d6c","9":"31d6c","10":"18e4e","11":"fa475","12":"37e29","13":"4cd1c","17":"d8754","18":"31d6c","19":"d95db","20":"31d6c","21":"31d6c","22":"31d6c","23":"60af3","24":"31d6c","25":"b36ec","26":"31d6c","27":"95288","28":"31d6c","29":"31d6c","30":"06749","31":"b4fb3","32":"18823","33":"31d6c","34":"00bc0","35":"fbfb0","36":"31d6c","37":"f8b27","38":"f1e80","39":"6a05e","40":"63b98","41":"31d6c","42":"18823","43":"511bd","44":"5318a","45":"31d6c","46":"5318a","47":"18823","48":"8c877","49":"a3247","50":"576ae","51":"0e77d","52":"18823","53":"31d6c","54":"31d6c","55":"31d6c","56":"ba6f8","57":"31d6c","58":"96fc4","59":"25656","60":"df059","61":"3f8cb","62":"429d0","63":"c51fe","64":"1fa4d","65":"b2ca4","66":"f3859","67":"31d6c","68":"31d6c","69":"31d6c","70":"31d6c","71":"91a66","72":"756f3","73":"31d6c","74":"31d6c","75":"31d6c","76":"31d6c","77":"31d6c","78":"31d6c","80":"31d6c","81":"31d6c","82":"31d6c","83":"31d6c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = "brot");
